angular.module('eficienciaFiscalModule')

    .directive('cbkWell', function () {

        return {
            restrict: 'EC',
            transclude: true,
            replace: true,
            scope: {
                titulo: '@',
                subTitulo: '@',
                icon: '@',
                color: '@',
                titleClass: '@',
                onClick: '&',
                label: '@',
                closeShow: '@',
                closeClick: '&',
                labelColor: '@',
                noMargin: '@',
                noPadding: '@',
                tituloStyle: '@'
            },
            template: ''
            + '<div class="well {{noPadding? \'\' : \'padding-10\'}} {{noMargin? \'\' : \'margin-10\'}} clearfix {{label ? \'overflow-hidden\' : \'\'}}">'
            + ' <button class="close" style="  margin-top: -4px" ng-if="closeShow" ng-click="closeClick()">×</button>'
            + ' <div style="margin: 10px 15px;" ng-if="titulo">'
            + '     <legend style="padding: 0; border:0;">'
            + '         <h2 class="{{color || \'text-primary\'}}" ng-click="onClick()" ng-style="style" style="{{!tituloStyle ? \'\' : tituloStyle}}">'
            + '             <i class="fa {{icon}} {{onClick ? \'cursor-pointer\' : \'\'}}"></i><span ng-if="icon">&nbsp;&nbsp;&nbsp;</span>'
            + '                 <span class="{{titleClass}}">{{titulo}}</span>'
            + '             <small ng-if="subTitulo">{{subTitulo}}</small>'
            + '         </h2>'
            + '     </legend>'
            + ' </div>'
            + ' <div class="well-label" ng-if="label" style="background-color: {{labelColor || \'#FFF\'}}; z-index: 1">{{label}}</div>'
            + ' <div ng-transclude></div>'
            + '</div>',
            link: function (scope) {
                if (scope.label)
                    scope.style = {'margin-right': '50px'};
            }
        };
    });
